import { http } from "../../config/http";
import { versionMotivoNaoEntrega } from "../../config/Versions";
import { MotivoNaoEntrega } from "../../config/Paths";
import { changeLoading } from "./loading.action";
import { changeNotify } from "./notify.action";

export const actionTypes = {
  INDEX: "MOTIVO_NAO_ENTREGA_INDEX",
  SHOW: "MOTIVO_NAO_ENTREGA_SHOW",
  DESTROY: "MOTIVO_NAO_ENTREGA_DESTROY",
  CHANGE: "MOTIVO_NAO_ENTREGA_CHANGE",
  SUCCESS: "MOTIVO_NAO_ENTREGA_SUCCESS",
  ERROR: "MOTIVO_NAO_ENTREGA_ERROR",
  SELECTED: "INDEX_SELECTED",
};

export const change = (payLoad) => ({
  type: actionTypes.CHANGE,
  payLoad,
});

export const success = (payLoad) => ({
  type: actionTypes.SUCCESS,
  payLoad,
});

export const error = (payLoad) => ({
  type: actionTypes.ERROR,
  payLoad,
});

//INDEX
export const indexResponse = (payLoad) => ({
  type: actionTypes.INDEX,
  payLoad,
});

export const indexSelected = (payLoad) => ({
  type: actionTypes.SELECTED,
  payLoad,
});

export const selecteds = (selecteds) => (dispatch) => {
  dispatch(indexSelected(selecteds));
};

export const index = () => (dispatch) => {
  return http
    .get(versionMotivoNaoEntrega + MotivoNaoEntrega)
    .then(function (res) {
      if (res.response !== "undefined") {
        if (res.request.status === 200) {
          dispatch(indexResponse(res.data.data));
          return res.data.data;
        }
      }
    })
    .catch((error) => {
      // Error
      if (error.response) {
        //A solicitação foi feita e o servidor respondeu com um código de status fora do intervalo 2XX
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        //  A solicitação foi feita, mas nenhuma resposta foi recebida
        console.log(error.request);
      } else {
        // Algo aconteceu na configuração da solicitação que acionou um erro
        console.log("Error", error.message);
      }
      console.log(error.config);
      dispatch(
        changeNotify({
          open: true,
          class: "error",
          msg: "Erro ao carregar a lista de motivos de não entrega. Tente recarregar a tela.",
        })
      );
    });
};

//STORE
export const store = (motivoNaoEntrega) => (dispatch) => {
 
  return http
    .post(versionMotivoNaoEntrega + MotivoNaoEntrega, {
      descricao: motivoNaoEntrega["descricao"],
      ativo: motivoNaoEntrega["ativo"],
      exigeObservacao: motivoNaoEntrega["exigeObservacao"],
      necessarioReentrega: motivoNaoEntrega["necessarioReentrega"],
    })
    .then((res) => {
      if (typeof res !== "undefined") {
        if (res.status === 200 || res.status === 201) {
            console.log(res)
          dispatch(
            changeNotify({
              open: true,
              class: "success",
              msg: motivoNaoEntrega["descricao"] + " cadastrado com sucesso",
            })
          );
          dispatch(index());
        } else {
          dispatch(
            changeNotify({
              open: true,
              class: "error",
              msg: "Erro ao cadastrar Motivo de Não Entrega",
            })
          );
        }
      }
    })
    .catch((erro) => {
      dispatch(
        changeNotify({
          open: true,
          class: "error",
          msg: "Erro ao salvar motivo de não entrega",
        })
      );
    });
};

//UPDATE
export const update = (data) => (dispatch) => {
  dispatch(
    changeLoading({
      open: true,
    })
  );
  return http
    .put(versionMotivoNaoEntrega + MotivoNaoEntrega + data.id, data)
    .then((res) => {
      dispatch(
        changeLoading({
          open: false,
        })
      );
      if (res !== "undefined") {
        if (res.status === 200 || res.status === 201) {
          dispatch(
            changeNotify({
              open: true,
              class: "success",
              msg: "Alterado com sucesso",
            })
          );
        }
        dispatch(index());
      }
    })
    .catch((erro) => {
      dispatch(
        changeNotify({
          open: true,
          class: "error",
          msg: "Erro ao salvar motivo de não entrega",
        })
      );
    });
};

//DESTROY
export const destroyResponse = (payLoad) => ({
  type: actionTypes.DESTROY,
  payLoad,
});

export const destroy = (id) => (dispatch) => {
  dispatch(
    changeLoading({
      open: true,
      msg: "Deletando...",
    })
  );
  return http
    .delete(versionMotivoNaoEntrega + MotivoNaoEntrega + id)
    .then((res) => {
      if (res !== "undefined") {
        if (res.status === 200) {
          dispatch(
            changeLoading({
              open: false,
            })
          );
          dispatch(
            changeNotify({
              open: true,
              class: "success",
              msg: "Excluido com Sucesso",
            })
          );
          dispatch(destroyResponse(id));
        }
        dispatch(index());
      }
    })
    .catch((error) => {
      // Error
      if (error.response) {
        //A solicitação foi feita e o servidor respondeu com um código de status fora do intervalo 2XX
        if (error.response.status === 404) {
          dispatch(
            changeLoading({
              open: false,
            })
          );
          dispatch(
            changeNotify({
              open: true,
              class: "error",
              msg: "Tipo de Despesa não encontrado",
            })
          );
        }
      } else if (error.request) {
        //  A solicitação foi feita, mas nenhuma resposta foi recebida
        dispatch(
          changeLoading({
            open: false,
          })
        );
        dispatch(
          changeNotify({
            open: true,
            class: "error",
            msg: "Sem resposta do servidor",
          })
        );
        dispatch(index());
        console.log(error.request);
      } else {
        // Algo aconteceu na configuração da solicitação que acionou um erro
        console.log("Error", error.message);
        dispatch(
          changeNotify({
            open: true,
            class: "error",
            msg: "Erro ao remover motivo de não entrega",
          })
        );
      }
      // console.log(error.config);
    });
};
